<template lang="pug">
#usersListContainer
  .usersListOverflow
    // users list
    input(type='text', placeholder='recherche', v-model='search')
    div
      users-lists(
        @update-user-mail='updateUserMail',
        @remove-user='removeUser',
        @sendcode='sendCode',
        @remove-users-pack='removeMutipleUser',
        @resend-pass-users-pack='sendMultipleCode',
        :user-list='usersList'
      )
    // users list when a search occurs
  #animeEmailOverlay(v-if='showEmailFields')
    #animeEmailCentering(@click='showEmailFields = !showEmailFields')
      #sendEmailContainer(v-on:click.stop='')
        input(type='email', v-model='animeEmail', :placeholder='target.name')
        input(type='submit', @click='preparSend')
  #addUserContainer
    #addUserForm
      input(type='text', v-model='newAnim', placeholder='prénom NOM')
      input(type='mail', v-model='newAnimMail', placeholder='courriel')
      input(type='submit', @click='createNewAnim')
      p.error {{ error }}
      p.success(v-if='register.name') {{ register.name }} : {{ register.code }}
    #addUsersList
      p ajout par fichier .csv
      input#fileUpload(
        type='file',
        ref='file',
        accept='.csv',
        v-on:change='handleFileUpload()'
      )
      input(type='submit', @click='csvAddUsers')
      #csvImportResult
        p.error(v-for='(err, index) in csvError', :key='index') {{ err }}
        p.success(v-for='(success, index) in csvSuccess', :key='index') {{ success }}
</template>

<script>
import axios from 'axios'

import usersLists from '@/components/admin/UserList'

let BACK_END_PATH = process.env.VUE_APP_BACK_END_PATH

export default {
  data() {
    return {
      usersList: [],
      search: '',
      newAnim: '',
      newAnimMail: '',
      error: '',
      csvError: '',
      csvSuccess: '',
      register: {
        name: '',
        code: '',
      },
      animeEmail: '',
      showEmailFields: false,
      target: {
        name: '',
        code: '',
      },
      file: '',
    }
  },
  mounted() {
    this.animatorsList()
  },
  methods: {
    removeMutipleUser() {
      let conf = confirm('Vous êtes sûr ?')
      if (conf) {
        for (let user in this.usersList) {
          if (this.usersList[user].multipleSelection) {
            this.removeUser(this.usersList[user].name)
          }
        }
      }
    },
    sendMultipleCode() {
      let conf = confirm('Vous êtes sûr ?')
      if (conf) {
        for (let user in this.usersList) {
          if (this.usersList[user].multipleSelection) {
            if (this.usersList[user].email !== '') {
              this.okToSend(this.usersList[user])
            } else {
              alert("pas d'adresse mail pour :" + this.usersList[user].name)
            }
          }
        }
      }
    },
    async updateUserMail(user) {
      let data = JSON.stringify({
        name: user.name,
        email: user.email,
      })

      let url = `${BACK_END_PATH}/updateMail`

      await axios({
        method: 'post',
        url,
        data,
      }).then(r => {
        // console.log(r)
        this.animatorsList()

        if (r.status !== 200) {
          alert('une erreur est survenu')
        }
      })
    },
    handleFileUpload() {
      // console.log()
      this.file = this.$refs.file.files[0]
    },
    async csvAddUsers() {
      let data = new FormData()

      data.append('file', this.file)

      let url = `${BACK_END_PATH}/csvAddUser`

      await axios
        .post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(r => {
          // console.log(r)
          this.animatorsList()
          this.csvError = r.data.error ? r.data.error.split(';') : ''
          this.csvSuccess = r.data.success ? r.data.success.split(';') : ''
        })
    },
    async preparSend() {
      // console.log("preparSend");
      this.showEmailFields = !this.showEmailFields

      this.sendCode({
        name: this.target.name,
        code: this.target.code,
        email: this.animeEmail,
      })
    },
    async sendCode(user) {
      if (user.email) {
        let data = JSON.stringify({
          name: user.name,
          email: user.email,
          code: user.code,
        })

        let url = `${BACK_END_PATH}/sendCode`

        await axios({
          method: 'post',
          url,
          data,
        }).then(r => {
          // console.log(r)
          this.animatorsList()
          if (r.data.success) {
            alert('mail envoyer')
          } else {
            alert('whoops')
          }
        })
      } else {
        this.target = user
        this.animeEmail = ''
        this.showEmailFields = !this.showEmailFields
      }
    },
    async okToSend() {
      let data = JSON.stringify({
        user: this.target,
        email: this.animeEmail,
      })

      let url = `${BACK_END_PATH}/sendCode`
      await axios({
        method: 'post',
        url,
        data,
      }).then(() => {
        this.showEmailFields = false
      })
    },
    async removeUser(username) {
      let data = JSON.stringify({
        name: username,
      })

      let url = `${BACK_END_PATH}/removeUser`
      await axios({
        method: 'post',
        url,
        data,
      }).then(() => {
        this.animatorsList()
      })
    },
    async createNewAnim() {
      if (this.newAnim.length <= 0) {
        this.error = 'champs incomplet'
      } else {
        this.error = ''
        let data = JSON.stringify({
          name: this.newAnim,
          email: this.newAnimMail,
        })

        let url = `${BACK_END_PATH}/newUser`
        await axios({
          method: 'post',
          url,
          data,
        }).then(r => {
          if (r.data.error) {
            this.error = r.data.error
          }
          if (r.data.success) {
            this.register.name = r.data.success.name
            this.register.code = r.data.success.code
            this.animatorsList()
          }
        })
      }
    },
    async animatorsList() {
      await axios.get(`${BACK_END_PATH}/users`).then(r => {
        for (let user in r.data) {
          r.data[user].visible = true
          r.data[user].editEmail = false
          r.data[user].multipleSelection = false
        }
        this.usersList = r.data
      })
    },
  },
  watch: {
    search() {
      if (this.search.length > 0) {
        for (const user in this.usersList) {
          this.usersList[user].visible = false
          if (
            this.usersList[user].name
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            this.usersList[user].code.indexOf(this.search) >= 0
          ) {
            this.usersList[user].visible = true
          } else {
            this.usersList[user].visible = false
          }
        }
      } else {
        this.usersList = this.usersList.filter(r => {
          r.visible = true
          return r
        })
      }
    },
  },
  components: {
    usersLists,
  },
}
</script>

<style >
#usersListContainer {
  display: flex;
  justify-content: center;
  flex-direction: row;
  margin: auto;
}
.usersListOverflow {
  width: 70%;
}
.usersContainer {
  background: white;
  padding: 5px 15px;
}
.handleOverflow {
  height: 85vh;
  overflow: auto;
}
.userContainer {
  display: grid;
}
.userContainer.regularGrid {
  grid-template-columns: 3fr 1fr 6fr 1fr 1fr 2fr;
}
.userContainer.multipleSelectGrid {
  grid-template-columns: 1fr 3fr 1fr 6fr 1fr 1fr 2fr;
}
.updateMail,
.removeUser,
.sendCode {
  cursor: pointer;
  text-align: center !important;
}

#animeEmailOverlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
#animeEmailCentering {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(200, 200, 200, 0.4);
}
#sendEmailContainer {
  display: flex;
  flex-direction: column;
  padding: 15px;
  background: #2d101e;
}
#addUserForm {
  display: flex;
  flex-direction: column;
  margin-top: 35px;
}
.centering {
  text-align: left;
  /* width: calc(100% / 5); */
}
#addUsersList > p {
  padding: 0 15px;
}

#addUsersList p,
#addUsersList input {
  color: white;
}
#addUsersList p.error {
  color: red !important;
}
#addUsersList p.success {
  color: green !important;
}
#csvImportResult {
  height: 54vh;
  overflow: auto;
  padding: 5px;
}
.removeUser:hover {
  color: red;
}
#addUserContainer {
  padding: 10px;
}
</style>
